import styled from 'styled-components';

export const CategoryRows = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const CategoryItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const CategoryLine = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(1)};

  & > .MuiFormControl-root {
    flex: 1;
  }
`;

export const DeleteSlot = styled.span`
  display: inline-flex;
`;

export const UsedByList = styled.div`
  ul {
    margin: ${({ theme }) => theme.spacing(0.5)} 0;
    padding-left: ${({ theme }) => theme.spacing(2)};
  }
`;

export const UsedByNote = styled.div`
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const DrawerIntro = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
